import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash-es'

import PsText from './PsText'
import { INFO_TYPE } from '@/constants/personalization-studio'

function PsInfo({ recommendation = {}, cssProps = {} }) {
  const infoType = get(recommendation, 'content.infoType', {})
  const text = get(recommendation, 'content.infoText', '')
  const font = get(recommendation, 'content.infoTextMetadata[0].font_size', '')
  const textWithButton = get(recommendation, 'content.infoWithBullet', false)
  const ariaLabel = get(recommendation, 'content.aria-label', '')

  const { HEADER, PRIMARY } = INFO_TYPE

  switch (infoType) {
    case HEADER:
      return <PsText text={text} font={font} cssProps={cssProps} ariaLabel={ariaLabel} />
    case PRIMARY:
      return <PsText text={text} font={font} textWithButton={textWithButton} cssProps={cssProps} ariaLabel={ariaLabel} />
    default:
      return null
  }
}

PsInfo.propTypes = {
  recommendation: PropTypes.object,
  cssProps: PropTypes.object,
}

export default PsInfo
